import { QuestionnaireForm } from '@app/questionnaire/components/QuestionnaireForm';

export const SingleParentQuestionnairePage = () => {
  return <QuestionnaireForm />;
};
